import React from 'react'

import LoadingDots from 'components/shared/LoadingDots'
import { InlineEditInput, Span } from '@driftt/tide-core-legacy'

import { APP_URL } from 'constants/ResourcesConstants'

import Nav from '../Nav'
import AnswerModal from '../AnswerModal'
import QuestionAdvancedModal from '../QuestionAdvancedModal'
import GoalActionModal from '../GoalActionModal'
import GoalRoutingModal from '../GoalRoutingModal'
import ConditionModal from '../ConditionModal'
import ScheduleModal from '../ScheduleModal'
import ExtensionInviteModal from '../ExtensionInviteModal'
import CalendarLinkModal from '../EditorCalendarLinkModal'
import EmailEditSenderModal from '../EmailEditSenderModal'
import SequenceInviteModal from '../SequenceInviteModal'
import SendEmailConfirmModal from '../SendEmailConfirmModal'
import EditorTokenModal from '../EditorTokenModal'
import EditorCtaButtonModal from '../EditorCtaButtonModal'
import GoogleAuthModal from '../GoogleAuthModal'
import PlaybookDraftToggle from '../PlaybookDraftToggle'
import SaveStatus from '../SaveStatus'
import DisableSalesSequenceConfirmModal from '../DisableSalesSequenceConfirmModal'

import style from './style.styl'

const Playbook = ({
  draft,
  onNameChange,
  children,
  editSenderModalVisible,
  tokenModalVisible,
  ctaButtonModalVisible,
  goalRoutingModalVisible,
  goalActionModalVisible,
  answerModalVisible,
  questionAdvancedModalVisible,
  extensionInviteModalVisible,
  calendarLinkModalVisible,
  scheduleModalVisible,
  conditionModalVisible,
  sequenceInviteModalVisible,
  googleAuthModalVisible,
  isOneTimeEmailPlaybook,
  isStatusLoading,
  isDraftEnabled,
  isAutosaveActive,
  sendEmailConfirmModalVisible,
  disableSalesSequenceModalVisible,
  isEmailPlaybook,
  isSignaturePlaybook
}) => {

  function handleExit() {
    let exitLink = `${APP_URL}/playbooks`
    if (isSignaturePlaybook) exitLink += `/list/signature`
    if (isEmailPlaybook) exitLink += `/list/email`
    window.location.href = exitLink
  }

  return (
    <div className={style.Playbook}>
      <header className="playbook-header flex-space-between">
        <InlineEditInput
          className="playbook-title-inline-edit-input"
          type="heading"
          headingSize="h3"
          value={draft.name}
          onChange={onNameChange}
        />
        <div className="playbook-save-content flex">
          <SaveStatus />
          <Span className="playbook-exit" onClick={handleExit}>
            Exit
          </Span>
          {!isOneTimeEmailPlaybook && (
            <div className="playbook-enable flex-space-between">
              <div>
                {!isAutosaveActive &&
                  isStatusLoading && (
                    <div className="playbook-enable-loading">
                      {isDraftEnabled ? 'Enabling' : 'Disabling'} <LoadingDots />
                    </div>
                  )}
                {(isAutosaveActive || !isStatusLoading) && 'This playbook is'}
              </div>{' '}
              <PlaybookDraftToggle />
            </div>
          )}
        </div>
      </header>
      <div className="playbook-content">
        <Nav playbookId={draft.id} />
        <div className="subcontent">{children}</div>
      </div>
      {calendarLinkModalVisible && <CalendarLinkModal />}
      {editSenderModalVisible && <EmailEditSenderModal />}
      {tokenModalVisible && <EditorTokenModal />}
      {ctaButtonModalVisible && <EditorCtaButtonModal />}
      {answerModalVisible && <AnswerModal />}
      {questionAdvancedModalVisible && <QuestionAdvancedModal />}
      {goalActionModalVisible && <GoalActionModal />}
      {goalRoutingModalVisible && <GoalRoutingModal />}
      {conditionModalVisible && <ConditionModal />}
      {extensionInviteModalVisible && <ExtensionInviteModal />}
      {scheduleModalVisible && <ScheduleModal />}
      {sequenceInviteModalVisible && <SequenceInviteModal />}
      {googleAuthModalVisible && <GoogleAuthModal />}
      {sendEmailConfirmModalVisible && <SendEmailConfirmModal />}
      {disableSalesSequenceModalVisible && <DisableSalesSequenceConfirmModal />}
    </div>
  )
}

export default Playbook



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/Playbook/component.js